import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    user: {},
    token: '',
    ifCompose: false,// 当前编辑状态
    patient: {},
    systemInfo: {},
    siweiReportArg: {},
    curPro: '',
    resourceTab: '',// 教师端资源tab
    ifExitMai: false,// 脉设备是否存在
  },

  mutations: {
    updateUser(state, data) {
      state.user = data;
      localStorage.setItem('user', JSON.stringify(data));
    },
    updateToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token);
    },
    updateIfCompose(state, ifCompose) {
      state.ifCompose = ifCompose;
    },
    updatePatient(state, data) {
      state.patient = data;
    },
    updateSystemInfo(state, data) {
      state.systemInfo = data;
    },
    updateSiweiReportArg(state, data) {
      state.siweiReportArg = data;
    },
    updateCurPro(state, data) {
      state.curPro = data;
    },
    updateResourceTab(state, data) {
      state.resourceTab = data;
    },
    updateIfExitMai(state, data) {
      state.ifExitMai = data;
    },
  }
});

export default store;
